import React, { Component, Fragment } from 'react';
import {Link} from 'react-router-dom';
import './Navbar.css';

export default class Navlink extends Component {

    render() {
        return (
            <Fragment>
                <Link to={"/" + this.props.page} className={this.props.active ? "active-navlink navlink" : "navlink"}>
                    <span>
                        {this.props.page}
                    </span>
                </Link>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Navbar/Navlink.js